import styled from 'styled-components';
import * as React from 'react';

import { SectionInfoNarrow } from '../layout/SectionInfoNarrow';
import { Container } from '../layout/Container';
import { SectionContact } from '../layout/SectionContact';
import { SectionServices } from '../layout/SectionServices';
import { Overlap } from '../layout/Overlap';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import { useParams } from 'react-router';
import { useQuery, useLazyQuery } from '@apollo/client';
import { Query, QueryGetPageContentInputArgs } from '../../../client/types/generated/types';
import { ImageCarousel } from '../layout/carousel/ImageCarousel_v1';
import { PageContentType } from '../../../server/global/enum';

import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';

export const PortalServicesStyle = styled.div``;

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const PortalServices: React.FC = () => {
  const params = useParams<{ urltag: string }>();

  const { data, loading } = useQuery<GetPageItem, QueryGetPageContentInputArgs>(CONTENT_ITEM, {
    skip: !params.urltag,
    fetchPolicy: 'network-only',
    variables: {
      input: { urltag: params.urltag, type: PageContentType.SERVICE }
    }
  });

  if (loading) {
    return null;
  }

  return (
    <>
      <Seo
        title={`Våre tjenester - PrivatMegleren - ${data?.getNdPageContent?.seo?.title}`}
        image={data?.getNdPageContent?.seo?.image ? data?.getNdPageContent?.seo?.image : undefined}
        description={data?.getNdPageContent?.seo?.text ? data?.getNdPageContent?.seo?.text : undefined}
      />
      <Page>
        <PortalServicesStyle>
          <ImageCarousel
            title={data?.getNdPageContent?.title}
            url={data?.getNdPageContent?.image}
            imageList={data?.getNdPageContent?.imageList}
            get_properties={false}
          />
          <Overlap yPos={-50}>
            <SectionInfoNarrow title={data?.getNdPageContent?.title} ingress={data?.getNdPageContent?.ingress} info={data?.getNdPageContent?.text} />
          </Overlap>
          {data?.getNdPageContent?.config?.showSubpageNews ? <SectionNewsCard /> : null}
          <SectionServices limit={12} />
          {data?.getNdPageContent?.config?.showSubpageContact ? <SectionContact style={{ paddingTop: '2em' }} /> : null}
        </PortalServicesStyle>
      </Page>
    </>
  );
};

export default PortalServices;

